import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { grey } from '@material-ui/core/colors';
import { FlexFlow } from '../styles/Layout';

const StyledRadioGroup = withStyles({
  root: {
    margin: 0,
    alignSelf: 'stretch',
  },
})(RadioGroup);

const StyledControlLabel = withStyles({
  root: {
    display: 'flex',
    flexFlow: 'row wrap',
    backgroundColor: 'transparent',
    color: grey[600],
    margin: '0 0 1em',
    transition: 'all 0.3s ease',
  },
  label: {
    display: 'none',
  },
})(FormControlLabel);

const StyledRadio = withStyles({
  root: {
    padding: 0,
    color: (props) => props.colorvalue || grey[600],
    backgroundColor: (props) => fade(props.colorvalue || grey[600], 0.2),
    transition: 'all 0.3s ease',
  },
})(Radio);

const ColorsPicker = ({ items, onChange, selectedItem }) => {
  const [currentValue, setCurrentValue] = useState(selectedItem.value);

  useEffect(() => {
    const { value } = selectedItem;
    setCurrentValue(value);

    return () => {
      setCurrentValue('');
    };
  }, [selectedItem]);

  const handleOnchange = (e, newValue) => {
    const selectItem = items.find((i) => i.value === newValue) || { value: '', item: '' };
    onChange(selectItem);
  };

  return (
    <StyledRadioGroup value={currentValue} onChange={handleOnchange}>
      <FlexFlow splitSpace="0.5em">
        {items.map(({ value }) => (
          <StyledControlLabel
            key={value}
            value={value}
            className={currentValue === value ? 'checked' : ''}
            control={<StyledRadio colorvalue={value} />}
          />
        ))}
      </FlexFlow>
    </StyledRadioGroup>
  );
};

ColorsPicker.defaultProps = {
  selectedItem: {
    value: '',
    label: '',
  },
};

ColorsPicker.propTypes = {
  selectedItem: PropTypes.shape(),
  onChange: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.string,
    }),
  ).isRequired,
};

export default ColorsPicker;
